import { 
    SET_ESTIMATION_DATA, 
    SET_ESTIMATION_LOADING, 
    SET_ESTIMATION_SUMMARY 
} from "../types"

const initialState = {
    data: [],   
    summary: [], 
    loading: false,
}

const estimationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ESTIMATION_LOADING:
            return { 
                ...state, 
                loading: action.payload 
            }

        case SET_ESTIMATION_DATA:
            return {
                ...state,
                data: action.payload,   
                loading: false,
            }

        case SET_ESTIMATION_SUMMARY:  
            return {
                ...state,
                summary: action.payload,
                loading: false,
            }

        default:
            return state
    }
}

export default estimationReducer
